module.exports = __webpack_public_path__ + "img/horizontal_7_7_9006.387d72e5.png";